import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import * as _ from "lodash";
import { MessageRendererService } from "src/app/services/message-renderer.service";
import { DocumentoService } from "src/app/services/documento.service";
import { PaginationContext } from "src/app/shared/object/pagination_context.model";
import { ConsoleService } from "src/app/shared/services/console.service";
import { DatesService } from "src/app/shared/services/dates.service";
import { FileDownloadService } from "src/app/shared/services/file-download.service";
import { FormValidatorsService } from "src/app/shared/services/form-validators.service";
import { SecurityService } from "src/app/shared/services/security.service";
import { CajaDiariaModalDetalleComponent } from './modal-detalle/modal-detalle.component';
import { CajaDiariaService } from 'src/app/services/caja-diaria.service';

@Component({
  selector: "app-caja-diaria",
  templateUrl: "./caja-diaria.component.html",
  styleUrls: ["./caja-diaria.component.scss"],
  providers: [SecurityService]
})
export class CajaDiariaComponent implements OnInit {

  @ViewChild(CajaDiariaModalDetalleComponent, { static: true }) modalDetalleCajaDiaria: CajaDiariaModalDetalleComponent

  // Form
  formHeader: FormGroup

  //Campos
  efectivoRecorrido: any

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  listaMovimientosTrasportista: any = null
  listaMovimientosVendedores: any = null
  listaMovimientosCajaLocal: any = null
  listaMovimientosResumen: any = null
  listaMovimientosRetirosDeposito: any = null
  listaMovimientosTotal: any = null
  private currentPayload: any = null
  loading: boolean = false
  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private cajaDiariaService: CajaDiariaService,
    private datesService: DatesService,
    private fb: FormBuilder,
    private fileDownloadService: FileDownloadService,
  ) {
    this.log = this.clog.log('CAJA DIARIA')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.createForm()
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      fechaCaja: [currentDate, [Validators.required]],
    });
  }

  detalle() {
    this.modalDetalleCajaDiaria.load(this.formHeader.get('fechaCaja').value)
  }

  buscar() {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.listaMovimientosTrasportista = {
      monto_efectivo: 0,
      monto_cheque: 0,
      monto_deposito: 0,
      monto_transferencia: 0,
      banco: [],
      monto_credito: 0,
      diferencia_monto_ingreso:0,
      diferencia_monto_egreso:0,
      pago_cuenta_utilizado:0,
      gasto:0,
    };

    this.listaMovimientosVendedores = {
      monto_efectivo: 0,
      monto_cheque: 0,
      monto_deposito: 0,
      monto_transferencia: 0,
      banco: [],
      monto_credito: 0,
      diferencia_monto_ingreso:0,
      diferencia_monto_egreso:0,
      pago_cuenta_utilizado:0,
      gasto:0,
    };

    this.listaMovimientosCajaLocal = {
      monto_efectivo: 0,
      monto_cheque: 0,
      monto_deposito: 0,
      monto_transferencia: 0,
      banco: [],
      monto_credito: 0,
      diferencia_monto_ingreso:0,
      diferencia_monto_egreso:0,
      pago_cuenta_utilizado:0,
      gasto:0,
    };

    this.listaMovimientosResumen = {
      monto_efectivo: 0,
      monto_cheque: 0,
      monto_deposito: 0,
      monto_transferencia: 0,
      banco: [],
      monto_credito: 0,
      diferencia_monto_ingreso:0,
      diferencia_monto_egreso:0,
      pago_cuenta_utilizado:0,
      gasto:0,
    };

    this.listaMovimientosRetirosDeposito = {
      pago_proveedores: 0,
      pago_caja_chica: 0,
      deposito_efectivo: 0,
      monto_protesto_cheque: 0,
      monto_reverso: 0,
    };

    this.listaMovimientosTotal = {
      total_ingreso: 0,
      total_egreso: 0,
    };
    //this.listaMovimientosAll = []

    const { fechaCaja } = this.formHeader.value
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_declaracion: fechaCaja,
      },
    }
    this.currentPayload = inputParams
    //this.docSeleccionado = 0
    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    //this.listaMovimientos = null
    //this.listaMovimientosAll = null

    this.cajaDiariaService.GetByCajaDiariaTransportista(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const registros = respuesta
      this.listaMovimientosTrasportista = registros



      // this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
      // this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      // this.paginationContext.CurrentPage = 1

      // this.listaMovimientosAll.forEach((mov, index) => {
      //   mov.additionalInfo = {}
      //   mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
      //   mov.additionalInfo.index = index
      //   mov.seleccion = false
      // })

      // this.showPage(this.paginationContext.CurrentPage)
      this.loading = false
    })

    this.cajaDiariaService.GetByCajaDiariaVendedores(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const registros = respuesta
      this.listaMovimientosVendedores = registros
      this.loading = false
    })

    this.cajaDiariaService.GetByCajaDiariaCajaLocal(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const registros = respuesta
      this.listaMovimientosCajaLocal = registros
      this.loading = false
    })

    this.cajaDiariaService.GetByCajaDiariaResumen(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const registros = respuesta
      this.listaMovimientosResumen = registros
      this.loading = false
    })

    this.cajaDiariaService.GetByCajaDiariaResumen(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const registros = respuesta
      this.listaMovimientosResumen = registros
      this.loading = false
    })

    this.cajaDiariaService.GetByCajaDiariaDepositoRetiro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const registros = respuesta
      this.listaMovimientosRetirosDeposito = registros
      this.loading = false
    })

    this.cajaDiariaService.GetByTotalCajaDiaria(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const registros = respuesta
      this.listaMovimientosTotal = registros
      this.loading = false
    })
  }

  documentoDownloadExcelPdf(type: 'XLS' | 'PDF') {

    const inputParams = _.cloneDeep(this.currentPayload)

    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    //inputParams.entidad.retornaExcel = type === 'XLS'
    inputParams.entidad.retornaPDF = type === 'PDF'

    this.log('inputParams', JSON.stringify(inputParams))

    this.cajaDiariaService.GetByPDFCajaDiaria(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.rutaArchivo)
    })
  }
}
